module.exports = __webpack_public_path__ + "assets/FF-PMS.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/landing/FF-PMS.png
// module id = 1214
// module chunks = 7